<template>
  <login-form v-on:logged-in="onLoggedIn"/>
</template>

<script>
import LoginForm from '@/components/LoginForm'

/**
* Screen for logging in a user. When login succeeds, redirects to /edit.
*/
export default {
  name: 'LoginScreen',
  components: { 'login-form': LoginForm },
  methods: {
    onLoggedIn () {
      this.$router.push({ name: 'edit' })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LoginScreen.vue